export default __webpack_public_path__ + "static/media/_saved-post-icon.a56415ff.svg";